/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2022-2024 (original work) Open Assessment Technologies SA
 *
 */
// Utils
import { multiGuard } from '@/core/guards/guardComposer';
import { getFeaturesGuard } from '@/core/guards/featureFlagGuard';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';
// Constants
import { FEATURE_GROUPS } from '@/constants/features';
import config from '@/config';

export const routing = [
    {
        path: [config.routes.groups.home],
        guard: multiGuard([
            getPermissionsGuard([{ resource: 'portal.group', scopes: ['view'] }]),
            getFeaturesGuard(FEATURE_GROUPS)
        ]),
        controller: () => import('./controllers/groups')
    },
    {
        path: [config.routes.groups.create],
        guard: multiGuard([
            getPermissionsGuard([{ resource: 'portal.group', scopes: ['create'] }]),
            getFeaturesGuard(FEATURE_GROUPS)
        ]),
        controller: () => import('./controllers/create.edit')
    },
    {
        path: [config.routes.groups.edit],
        guard: multiGuard([
            getPermissionsGuard([{ resource: 'portal.group', scopes: ['edit'] }]),
            getFeaturesGuard(FEATURE_GROUPS)
        ]),
        controller: () => import('./controllers/create.edit')
    },
    {
        path: [config.routes.groups.selectUsers],
        guard: multiGuard([
            getPermissionsGuard([{ resource: 'portal.group', scopes: ['view'] }]),
            getFeaturesGuard(FEATURE_GROUPS)
        ]),
        controller: () => import('./controllers/addUsers')
    },
    {
        path: [config.routes.groups.selectUsersForExisting],
        guard: multiGuard([
            getPermissionsGuard([{ resource: 'portal.group', scopes: ['view'] }]),
            getFeaturesGuard(FEATURE_GROUPS)
        ]),
        controller: () => import('./controllers/addUsers')
    }
];
